import React from 'react';
import CodeInput from 'react-verification-code-input';
import { ButtonV2 } from '@bbkAdminComponents/buttons';
import { LogInError } from '@bbkAdminComponents/log-in-flow/error';
import type * as LogInTypes from '@bbkAdminComponents/log-in-flow/log-in-types';
import { LogInTrouble } from '@bbkAdminComponents/log-in-flow/trouble';

type Props = {
  error?: LogInTypes.Error;
  sendVerificationEmail: LogInTypes.SendVerificationEmail;
  sending: LogInTypes.Sending;
  verify: (code: string) => Promise<boolean>;
};

export const Verify: React.FC<Props> = ({
  error,
  sending,
  sendVerificationEmail,
  verify,
}) => (
  <div>
    <div className="content">
      <div className="tw-mb-4 tw-font-semibold">Almost there...</div>
      {error && <LogInError error={error} />}
      <div className="verify">
        <label>
          We have emailed a verification code to you.
          <br /> Please paste or type that 6-digit code below:
        </label>
      </div>
      <div className="tw-inline-flex">
        <CodeInput
          type="number"
          fields={6}
          autoFocus
          onComplete={verify}
          className={`[&_input::selection]:tw-bg-[#f3e7f9] [&_input:focus]:tw-border-[#a45fe1] [&_input:focus]:tw-bg-[#f5f0f8] [&_input:focus]:tw-caret-[#9014fe] [&_input:last-child]:tw-border-r-2 [&_input:last-child]:tw-border-r-[#9014fe] [&_input]:tw-border-2 [&_input]:tw-border-r-0 [&_input]:tw-border-solid [&_input]:tw-border-[#9014fe] [&_input]:tw-bg-[#f3e7f9] [&_input]:tw-text-center [&_input]:tw-font-[inherit] [&_input]:tw-text-2xl`}
        />
      </div>
      {!sending && (
        <ButtonV2
          className="submitButtonFooter tw-mt-4"
          onClick={sendVerificationEmail}
          type="button"
          primary
        >
          Send me another email
        </ButtonV2>
      )}
    </div>
    <LogInTrouble />
  </div>
);
